import BlogTitleContainer from "../../../../components/pages/blog/blogPage/BlogTitle";

const BlogTitle = () => {
  return <BlogTitleContainer />;
};

export default BlogTitle;
